/** Canonical lane for legacy single-lane interval grids (matches DB default). */
export const DEFAULT_TEE_LANE_KEY = 'default';
export const MIN_PLAYERS = 1;
export const MAX_PLAYERS = 4;
export const BOOKING_PLAYER_COUNT_OPTIONS = [MIN_PLAYERS, 2, 3, MAX_PLAYERS];
/** High-level online booking flow steps shared by web and booking apps. */
export var BookingCheckoutStep;
(function (BookingCheckoutStep) {
    BookingCheckoutStep["Search"] = "search";
    BookingCheckoutStep["Checkout"] = "checkout";
    BookingCheckoutStep["Payment"] = "payment";
    BookingCheckoutStep["Confirmation"] = "confirmation";
})(BookingCheckoutStep || (BookingCheckoutStep = {}));
export function normalizeTeeTimeHm(raw) {
    const m = raw.match(/^(\d{1,2}:\d{2})/);
    if (m) {
        const [h, min] = m[1].split(':');
        return `${h.padStart(2, '0')}:${min}`;
    }
    return raw.length >= 5 ? raw.slice(0, 5) : raw;
}
export function parseReservationTeeTimeId(teeTimeId) {
    const pipe = teeTimeId.indexOf('|');
    const main = pipe >= 0 ? teeTimeId.slice(0, pipe) : teeTimeId;
    const laneKeyRaw = pipe >= 0 ? teeTimeId.slice(pipe + 1) : '';
    const laneKey = laneKeyRaw && laneKeyRaw.length > 0 ? laneKeyRaw : DEFAULT_TEE_LANE_KEY;
    const tIndex = main.indexOf('T');
    if (tIndex <= 0) {
        return { dateStr: '', timeStr: '', laneKey: DEFAULT_TEE_LANE_KEY };
    }
    const dateStr = main.slice(0, tIndex);
    const timeRaw = main.slice(tIndex + 1);
    return { dateStr, timeStr: normalizeTeeTimeHm(timeRaw), laneKey };
}
export function buildReservationTeeTimeId(dateStr, timeHm, laneKey) {
    const t = normalizeTeeTimeHm(timeHm);
    if (!laneKey || laneKey === DEFAULT_TEE_LANE_KEY) {
        return `${dateStr}T${t}`;
    }
    return `${dateStr}T${t}|${laneKey}`;
}
export function getReservationTeeTimeParts(teeTimeId) {
    const { dateStr, timeStr, laneKey } = parseReservationTeeTimeId(teeTimeId);
    return { dateYmd: dateStr, timeHm: timeStr, laneKey };
}
/** Map key for tee sheet reservation lookup by time row + spot (stable for default lane). */
export function teeSheetSlotKey(timeHm, spot, laneKey) {
    const t = normalizeTeeTimeHm(timeHm);
    if (!laneKey || laneKey === DEFAULT_TEE_LANE_KEY) {
        return `${t}-${spot}`;
    }
    const raw = String(laneKey).trim();
    const u = raw.toUpperCase();
    const laneForKey = u === 'F9' || u === 'B9' ? u : raw;
    return `${t}|${laneForKey}-${spot}`;
}
export function buildTeeTimeSelectValue(timeHm, laneKey) {
    const t = normalizeTeeTimeHm(timeHm);
    if (!laneKey || laneKey === DEFAULT_TEE_LANE_KEY) {
        return t;
    }
    return `${t}|${laneKey}`;
}
//# sourceMappingURL=index.js.map